var VueScrollTo = require('vue-scrollto');

const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

import Menu from "../menu/Menu.vue";
import AlfredComp from "../alfred/Alfred.vue";
import alfred from '../../assets/projects/alfred/alfred.png'
import watcher from '../../assets/projects/watcher/watcher_hidden2.png'
import upcoming from '../../assets/projects/hedvig/upcoming.png'



export default {
    name: "Main",
    data: function () {
        return {
            showProject: false,
            fakeScroll: false,
            ready: false,
            showProjects: false,
            projectFocus: 0,
            projectScrollBusy: false,
            projectEmited: false,
            aboutX: null,
            aboutStyle: null,
            aboutContentStyle: null,
            aboutInFocus: false,
            aboutFocus: 0,
            timeInter: null,
            videoSpeed: 0,
            touchDevice: false,
            scrollOpt: {
                container: 'body',
                easing: 'ease-in-out',
                offset: 0,
                force: true,
                cancelable: false,
                x: false,
                y: true
            },
            projects: [{
                    img: alfred,
                    id: "Alfred",
                },
                {
                    img: watcher,
                    id: "Watcher",
                    disabled: true
                },
                {
                    img: upcoming,
                    id: "Upcoming",
                    disabled: true
                }
            ],
            posts: [{
                text: "Soo i just started a rock band, it's pretty neat.",
                img: "https://images.pexels.com/photos/3689772/pexels-photo-3689772.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            }, {
                text: "This was pretty awesome"
            }, {
                text: "Soo i just started a rock band, it's pretty neat2.",
                img: "https://images.pexels.com/photos/3689772/pexels-photo-3689772.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            }]
        }
    },
    components: {
        Menu,
        AlfredComp
    },
    created: function () {
        this.deviceGotTouch()
        window.addEventListener('resize', this.deviceGotTouch);
        setTimeout(() => {
            window.scrollTo(0, 0)
            this.ready = true
            enableBodyScroll(document.querySelector("body"))
            console.log(window.location);
            let extra = window.location.hash.split("=");
            console.log(extra);
            /* if (extra[1]) {
                this.initProjects()
                const index = this.projects.map(e => e.id).indexOf(extra[1]) - 1
                this.updateProjectScroll(index + 2, true)
            } */
            this.xTransform = window.innerWidth / 5
        }, 500)
    },
    props: ['emitProject'],
    methods: {
        deviceGotTouch() {
            if (this.projectFocus > 0) location.reload()
            try {
                document.createEvent("TouchEvent");
                this.touchDevice = true;
            } catch (e) {
                console.log(window.innerWidth)
                if (window.innerWidth < 900) this.touchDevice = true;
                else this.touchDevice = false;
            }
        },
        docHeight: function (doc) {
            if (!document.getElementById(doc)) return 0
            return document.getElementById(doc).offsetHeight
        },
        selectProject: function (project) {
            /* if (project.disabled) return alert("Projektet finns inte än")
            this.projectEmited = true
            enableBodyScroll(document.querySelector("body"))
            this.$router.push(project.id)
            console.log(project) */
            if (project.id === "Alfred") {
                this.showProject = true
            }
        },
        scrollIsUp: function (event) {
            return event.deltaY < 0
        },
        stopWheel: function (scroll) {
            scroll.preventDefault()
            scroll.stopPropagation();
        },
        newScrollPos: function (scroll) {
            if (this.showProject) return
            if (this.aboutInFocus) return this.aboutScroll(scroll)
            if (this.fakeScroll || this.projectEmited) return
            if (!this.ready) return this.stopWheel(scroll)
            if (this.showProjects) {
                this.stopWheel(scroll)
                return this.projScroll(scroll)
            }
            if (this.aboutFocus === 3) {
                let totalAboutScroll = this.docHeight("startBox") + this.docHeight("projectPhonesBox") + this.docHeight("videoBox") + window.innerHeight
                console.log(totalAboutScroll)
                if ((scroll.pageY + 200 < totalAboutScroll) && this.scrollIsUp(scroll)) {
                    return this.reInitAboutScroll()
                }
            } else if (this.projectFocus === 4) {
                // Reinit project scroll
                let totalProjectScroll = document.getElementById("startBox").offsetHeight + window.innerHeight
                if ((scroll.pageY - 200 < totalProjectScroll) && this.scrollIsUp(scroll)) {
                    return this.initProjects(false)
                }
            } else if (scroll.pageY - 500 > document.getElementById("startBox").offsetHeight) {
                if (!this.showProjects) this.initProjects()
            } else {
                if (this.showProjects) this.showProjects = false
            }
        },
        aboutScroll: function (scroll) {
            if (this.aboutFocus > 2) return
            let addOn = (this.scrollIsUp(scroll)) ? -0.02 : 0.02
            if (this.aboutX <= 0 && addOn <= 0) addOn = 0
            this.aboutX += addOn
            if (this.aboutX <= 0 && addOn < 0) return this.revertAboutScroll()
            if ((addOn < 0 && this.aboutFocus === 1) || (this.aboutX < 1.02)) {
                this.aboutFocus = 1
                this.aboutStyle = {
                    transform: 'scale(' + (10 - (this.aboutX * 9)) + ')'
                }
                this.aboutContentStyle = {
                    opacity: this.aboutX - 0.02
                }
            } else {
                this.aboutFocus = 2
                this.aboutX = 1.02
                /* this.aboutX += addOn * 700
                console.log(document.querySelector("#videoContentBox").scrollHeight)
                document.querySelector("#videoContentBox").scrollTo(0, this.aboutX)
                console.log(this.aboutX) */

            }
        },
        dunno: function () {
            this.timeInter = setInterval(() => {
                if (document.querySelector("#videoPlayer").paused) document.querySelector("#videoPlayer").play()
                console.log(this.videoSpeed)
                this.videoSpeed = (this.videoSpeed / 1.2)
                document.querySelector("#videoPlayer").playbackRate = this.videoSpeed.toFixed(2);
            }, 100)
        },
        revertAboutScroll: function () {
            this.aboutFocus = 0
            this.aboutX = 0
            this.aboutInFocus = false
            this.initProjects(false)
        },
        disableAboutScroll: function () {
            enableBodyScroll(document.querySelector("body"))
            this.aboutInFocus = false
        },
        disableProjectScroll: function () {
            this.projectFocus = 0
            this.showProjects = false
        },
        projScroll: function (scroll) {
            if (this.projectScrollBusy || this.fakeScroll || this.projectFocus === 4) return
            if (this.scrollIsUp(scroll)) {
                if (this.projectFocus === 1) {
                    this.disableProjectScroll()
                    this.makeFakeScroll(document.querySelector("#startHeader"), true, 400)
                } else {
                    this.updateProjectScroll(-1)
                }
            } else if (!this.scrollIsUp(scroll)) {
                this.updateProjectScroll(1)
            }
        },
        updateProjectScroll: function (change, set = false) {
            if (set) this.projectFocus = change
            else this.projectFocus += change
            this.projectScrollBusy = true
            setTimeout(() => {
                this.projectScrollBusy = false
            }, 1200)
            if (this.projectFocus === 4) this.initAboutScroll()

        },
        reInitAboutScroll: function () {
            this.aboutInFocus = true
            VueScrollTo.scrollTo(document.querySelector("#videoBox"), 500, this.scrollOpt)
            disableBodyScroll(document.querySelector("body"))
            setTimeout(() => {
                this.aboutFocus = 2
            }, 500)
        },
        initAboutScroll: function () {
            setTimeout(() => {
                VueScrollTo.scrollTo(document.querySelector("#videoBox"), 500, this.scrollOpt)
            }, 500)
            setTimeout(() => {
                this.projectScrollBusy = false
                this.showProjects = false
                this.aboutX = 0
                this.aboutFocus = 1
                this.aboutInFocus = true
            }, 1000)
        },
        makeFakeScroll: function (elem, setScrollState = null, offset = 0) {
            this.scrollOpt.offset = offset
            if (setScrollState !== null) {
                console.log("Setting scroll state to:" + setScrollState)
                if (setScrollState === false) disableBodyScroll(document.querySelector("body"))
            }
            this.fakeScroll = true
            VueScrollTo.scrollTo(elem, 700, this.scrollOpt)
            setTimeout(() => {
                this.fakeScroll = false
                if (setScrollState === true) enableBodyScroll(document.querySelector("body"))
            }, 700)
        },
        initProjects: function (start = true) {
            this.showProjects = true
            this.makeFakeScroll(document.querySelector("#projectPhonesBox"), false)

            if (start) {
                console.log("Init projects")
                setTimeout(() => {
                    this.updateProjectScroll(1, true)
                }, 500)
            } else {
                console.log("Re-init projects")
                setTimeout(() => {
                    this.updateProjectScroll(3, true)
                }, 500)
            }
        }

    }
};